import { Info } from "lucide-react";
import { useDemo } from "@/demo/DemoContext";

export default function DemoBanner() {
  const { openBooking } = useDemo();
  return (
    <div
      data-testid="demo-banner"
      className="flex items-center justify-center gap-2 px-8 flex-wrap"
      style={{
        background:
          "linear-gradient(90deg, rgba(245, 158, 11, 0.10) 0%, rgba(245, 158, 11, 0.06) 100%)",
        borderBottom: "1px solid rgba(245, 158, 11, 0.25)",
        padding: "7px 32px",
      }}
    >
      <Info size={12} color="#F59E0B" style={{ flexShrink: 0 }} />
      <span
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
          color: "var(--text-secondary)",
          letterSpacing: "-0.005em",
        }}
      >
        <span style={{ fontFamily: "'JetBrains Mono', monospace", color: "#F59E0B", fontSize: 10, letterSpacing: "0.10em", marginRight: 8, textTransform: "uppercase" }}>
          Demo Mode
        </span>
        You're viewing a live demo. All data is illustrative. Book a Growth Audit to see this built on your actual pipeline.
      </span>
      <button
        data-testid="demo-banner-cta"
        onClick={openBooking}
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
          fontWeight: 600,
          color: "#F59E0B",
          background: "transparent",
          border: "none",
          padding: "2px 6px",
          borderRadius: 4,
          cursor: "pointer",
          textDecoration: "underline",
          textUnderlineOffset: 3,
        }}
      >
        Book Now →
      </button>
    </div>
  );
}
